import React, { useState, useEffect } from 'react'
import Layout from '../../../brands/components/Layout'
import { Formik } from 'formik'
import { InputField } from '../../../../components'
import SelectField from '../../../../components/Form/Select'
import TextAreaField from '../../../../components/Form/TextArea'
import './index.css'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAppDispatch } from '../../../../redux/hook'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { getLookupValues } from '../../../userslisting/createuser/api'
import { uploadEmployeeFiles, loadAssignment } from '../../api'
import { employeeFileSchema } from '../schema'
import Select from 'react-select'
import { FormValues, Lookupdata, User } from '../types'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { MAX_CHAR_COUNT } from '../../../../utils/index'
import { getAllAdminUsers } from '../../../userslisting/api'

const initialValues: FormValues = {
    employeeName: {
        label: '',
        value: '',
        firstName: '',
        lastName: '',
    },
    title: '',
    file: null,
    type: '',
    filetype: '',
    fileName: '',
    link: null,
    description: '',
    isEditing: false,
}

const UploadFile: React.FC = () => {
    const [formValues, setFormValues] = useState(initialValues) //setFormValues
    const [userList, setUserList] = useState([])
    const [resourcetypeOptions, setResourceTypeOptions] = useState<
        { label: string; value: string; id?: number | null }[]
    >([])
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const location = useLocation()
    const lookups = async () => {
        dispatch(SHOW_LOADER())
        try {
            const lookupValues = await getLookupValues()
            const resourceTypeData = lookupValues?.data?.filter(
                (item: Lookupdata) => item.lookUpType === 'ResourceType'
            )
            // Transform filtered results into label and value format for ResourceType
            const transformedFreqTypeData = resourceTypeData.map(
                (item: Lookupdata) => ({
                    label: item.lookUpValue,
                    value: item.lookUpValue,
                    id: item.id,
                })
            )
            setResourceTypeOptions(transformedFreqTypeData)
            dispatch(HIDE_LOADER())
        } catch (err) {
            // Handle any errors here
            console.error('Error fetching:', err)
            dispatch(HIDE_LOADER())
        }
    }
    const laodAllUserData = async () => {
        try {
            const res = await getAllAdminUsers({
                advancedSearch: {
                    keyword: null,
                },
                isglobalSearch: false,
                isActiveFilter: true,
                recordsPerPage: 1000,
            })

            const transformedData = res.data.data.map((item: User) => ({
                label: item.name,
                value: item.id,
                firstName: item.name,
                lastName: item.name,
            }))
            setUserList(transformedData)
        } catch (err) {
            console.error('Error fetching:', err)
        }
    }

    useEffect(() => {
        laodAllUserData()
        lookups()
    }, [])

    useEffect(() => {
        const loadFormData = async (id: string) => {
            const res = await loadAssignment(id)
            const user: User[] = userList.filter(
                (item: User) => item.value === res.userId
            )
            setFormValues({
                employeeName: {
                    label: user[0].label,
                    value: user[0].value,
                    firstName: '',
                    lastName: '',
                },
                title: res.title,
                type: res.fileType,
                filetype: res.fileType,
                fileName: res.filePath ? res.filePath.split('/').pop() : '',
                link: res?.link || '',
                description: res.description,
                isEditing: true,
            })
            dispatch(HIDE_LOADER())
        }

        const pathArray = location.pathname.split('/')
        if (pathArray[3] === 'edit' && userList?.length > 0) {
            dispatch(SHOW_LOADER())
            loadFormData(pathArray[4])
        }
    }, [location.pathname, userList])

    const handleFileChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        setFieldValue: (field: string, value: any) => void
    ) => {
        const file = e.target.files?.[0]
        setFieldValue('file', file)
        setFieldValue('fileName', file?.name)
        setFieldValue('link', '')
        setFieldValue('filetype', file?.name.split('.').pop())
    }

    const customStyles = {
        control: (provided: any) => ({
            ...provided,
            padding: '.375rem 0.60rem .375rem .35rem',
        }),
        multiValueRemove: () => ({
            display: 'none', // Hide the remove icon
        }),
        clearIndicator: () => ({
            display: 'none', // Hide the clear indicator
        }),
        indicatorSeparator: () => ({
            display: 'none', // Hide the clear indicator
        }),
        dropdownIndicator: () => ({
            color: '#000',
            fontSize: '3px',
            // marginRight: '4px',
        }),
    }

    const getFileTypeId = (
        resourceType: string | null | undefined | number
    ): string | any => {
        const type = resourcetypeOptions.find(
            (type) => type.value === resourceType
        )
        return type ? type?.id : null
    }
    const submitFunction = async (values: FormValues) => {
        const pathArray = location.pathname.split('/')

        const formData = new FormData()
        formData.append('UserId', values.employeeName.value)
        formData.append('Title', values.title)
        formData.append('Description', values.description)
        formData.append('FileTypeId', getFileTypeId(values.type))
        formData.append('Link', values.link || '')
        formData.append('File', (values.file as File) || '')
        dispatch(SHOW_LOADER())
        if (pathArray[3] === 'edit') {
            formData.append('EmployeeFileId', pathArray[4])
        }
        try {
            const res = await uploadEmployeeFiles(formData)
            if (res) {
                dispatch(HIDE_LOADER())
                dispatch(
                    SHOW_NOTIFICATION({
                        message:
                            pathArray[3] === 'edit'
                                ? 'Succssfully Edited'
                                : 'Succssfully Uploaded',
                        type: 'success',
                    })
                )
                navigate('/emp/files')
            }
        } catch (err) {
            console.error('Error fetching:', err)
            dispatch(
                SHOW_NOTIFICATION({
                    message: 'Failed to Uploaded',
                    type: 'error',
                })
            )
            dispatch(HIDE_LOADER())
        }
    }

    return (
        <div>
            <Layout>
                <div className="">
                    <div className="mb-3">
                        <h4>Upload Employee Files</h4>
                    </div>
                    <div className="upload-form">
                        <Formik
                            initialValues={formValues}
                            validationSchema={employeeFileSchema}
                            onSubmit={submitFunction}
                            enableReinitialize
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                setFieldValue,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="row mrg-top">
                                        <div className="col-sm-6 col-md-12">
                                            <label>Employee Name</label>
                                            <Select
                                                className="mt-2"
                                                options={userList}
                                                value={values.employeeName}
                                                onChange={(
                                                    selectedOption: any
                                                ) => {
                                                    setFieldValue(
                                                        'employeeName',
                                                        selectedOption
                                                    )
                                                }}
                                                styles={customStyles}
                                                placeholder="Select Employee"
                                                onBlur={handleBlur}
                                            />
                                            <div style={{ color: 'red' }}>
                                                {touched.employeeName?.label &&
                                                    errors.employeeName?.label}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mrg-top mt-3">
                                        <div className="col-sm-6 col-md-12">
                                            <InputField
                                                type="text"
                                                lable={'Title'}
                                                name="title"
                                                value={values.title}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.title}
                                                touched={touched.title}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mrg-top">
                                        <div className="col-sm-6 col-md-12">
                                            <SelectField
                                                name="type"
                                                label="Resource Type"
                                                options={[
                                                    {
                                                        value: '',
                                                        label: 'Select',
                                                    },
                                                    ...resourcetypeOptions,
                                                ]}
                                                value={values.type}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                    setFieldValue(
                                                        'filetype',
                                                        ''
                                                    )
                                                    setFieldValue(
                                                        'fileName',
                                                        ''
                                                    )
                                                    setFieldValue('link', null)
                                                    setFieldValue('file', null)
                                                }}
                                                onBlur={handleBlur}
                                                error={errors.type}
                                                touched={touched.type}
                                                defaultValue="option1"
                                            />
                                        </div>
                                    </div>

                                    <div className="row mrg-top">
                                        <div className="col-sm-6 col-md-12">
                                            <InputField
                                                type="text"
                                                lable={'Link'}
                                                name="link"
                                                value={values.link || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={
                                                    values.type &&
                                                    values.type?.toLowerCase() ===
                                                        'link'
                                                        ? errors.link
                                                        : ''
                                                }
                                                touched={touched.link}
                                                disabled={
                                                    !values.type ||
                                                    values.type?.toLowerCase() !==
                                                        'link'
                                                        ? true
                                                        : false
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row mrg-top">
                                        <div className="">
                                            <label>Select File</label>
                                            <div className="file-section">
                                                <span
                                                    className={
                                                        !values.type ||
                                                        values.type?.toLowerCase() ===
                                                            'link'
                                                            ? 'dis-span'
                                                            : ''
                                                    }
                                                >
                                                    {values.fileName}
                                                </span>
                                                <input
                                                    type="file"
                                                    className="input-file"
                                                    id="file"
                                                    name="file"
                                                    onChange={(e) => {
                                                        handleFileChange(
                                                            e,
                                                            setFieldValue
                                                        )
                                                    }}
                                                    onBlur={handleBlur}
                                                    // value={formik.values.filetype}
                                                    disabled={
                                                        !values.type ||
                                                        values.type?.toLowerCase() ===
                                                            'link'
                                                    }
                                                />
                                                <label
                                                    htmlFor="file"
                                                    className="btn btn-upload"
                                                >
                                                    BROWSE
                                                </label>
                                            </div>
                                            <div>
                                                {values.type &&
                                                values.type?.toLowerCase() !==
                                                    'link' ? (
                                                    <p
                                                        style={{
                                                            color: 'red',
                                                        }}
                                                    >
                                                        {errors.filetype}
                                                    </p>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mrg-top">
                                        <div className="col-sm-6 col-md-12">
                                            <TextAreaField
                                                name="description"
                                                label="Description"
                                                placeholder=""
                                                value={values.description}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.description}
                                                touched={touched.description}
                                                defaultValue=""
                                                rows={10}
                                                maxLength={MAX_CHAR_COUNT}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-4 mb-4">
                                        <div className="d-flex justify-content-between">
                                            <div></div>
                                            <div>
                                                <div className="button-block ">
                                                    <button
                                                        className="button button-primary me-5"
                                                        type={'submit'}
                                                    >
                                                        UPLOAD
                                                    </button>
                                                    <a
                                                        className="button button-outline"
                                                        onClick={() =>
                                                            navigate(
                                                                '/emp/files'
                                                            )
                                                        }
                                                    >
                                                        CANCEL
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default UploadFile
